import { render, staticRenderFns } from "./WsOrgsUpdateTicket.vue?vue&type=template&id=164db5e0&scoped=true"
import script from "./WsOrgsUpdateTicket.vue?vue&type=script&lang=js"
export * from "./WsOrgsUpdateTicket.vue?vue&type=script&lang=js"
import style0 from "./WsOrgsUpdateTicket.vue?vue&type=style&index=0&id=164db5e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164db5e0",
  null
  
)

export default component.exports